<template>
  <div class="card card-primary card-outline">
    <div class="card-header">
      <h3 class="card-title" style="margin-top: 10px">
        Son 10 Yatırım/Çekim Hareketi
      </h3>

      <div class="card-tools">
        <button class="btn btn-primary btn-sm">Tümünü Göster</button>
      </div>
    </div>
    <!-- /.card-header -->
    <div class="card-body table-responsive p-0" style="height: 280px">
      <div class="overlay-wrapper">
        <div class="overlay" v-if="overlay">
          <i class="fas fa-3x fa-spinner fa-spin"></i>
        </div>
        <table class="table table-head-fixed text-nowrap">
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>İşlem Tipi</th>
              <th>Zaman</th>
              <th>Tutar</th>
              <th>Para Birimi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in datas"
              :key="index"
              :class="{ 'bg-danger': !data.type }"
            >
              <td>{{ data.transaction }}</td>
              <td>{{ data.type ? "Yatırım" : "Çekim" }}</td>
              <td>{{ data.date | DateFormat }}</td>
              <td>{{ data.amount.toFixed(2) }}</td>
              <td>{{ data.curreny }}</td>
            </tr>
            <td v-if="datas.length == 0" colspan="5" class="text-center">
              Kayıt Bulunamadı
            </td>
          </tbody>
        </table>
      </div>
    </div>
    <!-- /.card-body -->
  </div>
</template>
<script>
export default {
  props: ["code"],
  data() {
    return {
      datas: [],
      overlay: false,
    };
  },
  methods: {
    getDatas() {
      this.overlay = true;
      this.$http
        .get("Finance/ListLast10Finance/" + this.code)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getDatas();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Customer/CustomerLast10Finance.vue